import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6cjsp5frk5: FaireBrandEntity = {
  token: "b_6cjsp5frk5",
  type: "brand",
  name: "Alto Imports Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/aff6a43307c458d5c41914abeb8abda1f44e5d341feb3a87ccc3a9bcec23fb69.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1a8815fb6120e99622351aedba24ddf673efba51e29315d433ceb311a2287f62.png",
  logoUrl:
    "https://cdn.faire.com/fastly/aff6a43307c458d5c41914abeb8abda1f44e5d341feb3a87ccc3a9bcec23fb69.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1a8815fb6120e99622351aedba24ddf673efba51e29315d433ceb311a2287f62.png",
  location: "WARWICK, PA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 1,
  isTopShop: true,
  isInsider: true,
  description:
    "Alto Imports was founded with a simple vision: to share the true flavors of Italy with the U.S. market. We work directly with family-owned producers to bring in olive oils, pastas, vinegars, and sweets that reflect generations of craftsmanship. Every product we carry is chosen for its quality and authenticity, so retailers can trust they are offering their customers the very best of Italy.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:57.744Z",
    importedBy: "entity-db-cli",
  },
};
